import React from 'react';
import { useEffect } from 'react';
import AOS from 'aos';
import '../Pages/Style.css';

const Recruiting = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,  // animation time in ms
            once: true,      // animate only once when scrolling down
            easing: 'ease-in-out',
            offset: 120,
        });
    }, []);

    return (
        <div id='content' >
            {/* Background image section with left text */}
           <div
                className="home-background d-flex align-items-start"
                id="recruiting-background"
                style={{
                    backgroundImage: `url('/Photos/image-attractive-smiling-guy-dressed-new-year-party-pointing-fingers-right-showing-advert.jpg')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'top',
                    height: '450px',
                    color: 'white' // optional: white text for better contrast
                }}
            >
                <div className="w-100 text-end p-4 pt-5 me-4">
                    <h1 className="text-whitee">Recruitment</h1>
                </div>
            </div>
            <div className="container" data-aos="fade-right">
                <h3 className="text-primary" id='JOB'>Recruitment Process</h3>


            </div>
            <div class="container my-5" >
                {/* <h3 class="text-center mb-4">Recruitment Process</h3> */}

                <div class="row g-4">

                    <div class="step-block" data-aos="fade-right">
                        <h2>1. Workforce Planning & Job Analysis</h2>
                        <p>Workforce Planning involves assessing the current and future workforce needs. Job Analysis defines the responsibilities, qualifications, and skills required for the role.</p>
                        <p>Job Analysis: Understanding the roles and responsibilities of the position that needs to be filled. This includes determining the required qualifications, skills, experience, and other job specifications.</p>
                    </div>



                    <div class="step-block" data-aos="fade-right">
                        <h2>2. Creating a Job Description</h2>
                        <p>Based on the analysis, a detailed job description is created including title, duties, skills, qualifications, compensation, location, and reporting structure.</p>
                        <ul>
                            <li className='text-dark'>Job title</li>
                            <li className='text-dark'>Responsibilities and duties</li>
                            <li className='text-dark'>Required skills and qualifications</li>
                            <li className='text-dark'>Compensation and benefits</li>
                            <li className='text-dark'>Reporting structure</li>
                            <li className='text-dark'>Location and work environment</li>
                        </ul>
                    </div>


                    <div class="step-block" data-aos="fade-right">
                        <h2>3. Sourcing Candidates</h2>
                        <p>Internally by promoting staff, or externally via job boards, agencies, and platforms like LinkedIn and career fairs.</p>
                        <p>External Recruitment: Posting the job on job boards, social media platforms, and company websites. This can also involve working with recruitment agencies, attending career fairs, or leveraging professional networks like LinkedIn.</p>
                    </div>



                    <div class="step-block" data-aos="fade-right">
                        <h2>4. Application Collection</h2>
                        <p>Collecting resumes, cover letters, and questionnaires through email or job portals.</p>

                    </div>



                    <div class="step-block" data-aos="fade-right">
                        <h2>5. Screening and Shortlisting</h2>
                        <p>Initial filtering of applications, followed by phone or video screening to assess qualifications and suitability.</p>
                        <p>Phone or Video Screening: Conducting brief interviews to further assess qualifications and determine if the candidate is a good fit.</p>
                    </div>

                    <div class="step-block" data-aos="fade-right">
                        <h2>6. Interview Process</h2>
                        <p>Structured, unstructured, panel interviews or skills assessments are conducted to evaluate candidates thoroughly.</p>
                        <ul>
                            <li className='text-dark'>Structured Interviews: Pre-determined questions are asked to all candidates.</li>
                            <li className='text-dark'>Unstructured Interviews: Open-ended questions that allow for more spontaneous conversation.</li>
                            <li className='text-dark'>Panel Interviews: Multiple interviewers assess the candidate at the same time.</li>
                            <li className='text-dark'>Skills Assessment: Some positions may require a test or task to assess job-specific skills.</li>
                        </ul>
                    </div>

                    <div class="step-block" data-aos="fade-right">
                        <h2>7. Reference and Background Checks</h2>
                        <p>Verification of employment history, references, criminal background, credit, and academic credentials.</p>
                        <p>Background Checks: Conducting criminal background checks, credit checks, and verifying educational credentials to ensure the candidate’s history aligns with the information they provided.</p>
                    </div>

                    <div class="step-block" data-aos="fade-right">
                        <h2>8. Making the Job Offer</h2>
                        <p>A formal offer is extended with salary, start date, terms, and benefits. Candidate can accept, negotiate, or decline.</p>
                        <ul>
                            <li className='text-dark'>Salary and compensation package</li>
                            <li className='text-dark'>Start date</li>
                            <li className='text-dark'>Benefits and perks</li>
                            <li className='text-dark'>Terms of employment (e.g., full-time, part-time, contract)</li>
                        </ul>
                    </div>

                    <div class="step-block" data-aos="fade-right">
                        <h2>9. Onboarding</h2>
                        <p>Includes pre-boarding tasks and formal onboarding with orientation, system access, and initial training.</p>
                        <p>Orientation and Training: Introducing the new hire to the company culture, team, and systems. Providing any necessary training or resources to help them succeed in their role.</p>
                    </div>

                    <div class="step-block" data-aos="fade-right">
                        <h2>10. Evaluation of Recruitment Process</h2>
                        <p>After hiring, the recruitment team typically evaluates the success of the recruitment process, assessing how effectively candidates were sourced, how long the process took, and whether the new hire is successful in the role.</p>
                        <p>Feedback is gathered from the hiring managers and candidates to improve future recruitment efforts.</p>
                    </div>

                </div>
            </div>
            {/* <div className='container'>
                <form
                    action="https://delightconsultancy.in/submit-form.php"
                    method="POST"
                    className="p-4 border rounded bg-light"
                >

                    <div className="mb-3">
                        <label htmlFor="name" className="form-label">Name</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            className="form-control"
                            placeholder="Enter your name"
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            className="form-control"
                            placeholder="Enter your email"
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="phone" className="form-label">Phone</label>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            className="form-control"
                            placeholder="Enter your phone number"
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="message" className="form-label">Message</label>
                        <textarea
                            id="message"
                            name="message"
                            className="form-control"
                            rows="4"
                            placeholder="Your message"
                            required
                        ></textarea>
                    </div>

                    <button type="submit" className="btn btn-primary">Submit</button>

                </form>
            </div> */}





        </div>
    );
};
export default Recruiting;
